// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-components-search-criteria-module__titleText--ub88F {
  display: inline-block;
  margin-right: 10px;
  font-size: 14px;
  text-transform: uppercase;
}

.src-js-components-search-criteria-module__panelBody--boRbL {
  background-color: #828e9a;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/search-criteria.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".titleText {\n  display: inline-block;\n  margin-right: 10px;\n  font-size: 14px;\n  text-transform: uppercase;\n}\n\n.panelBody {\n  background-color: #828e9a;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"titleText": `src-js-components-search-criteria-module__titleText--ub88F`,
	"panelBody": `src-js-components-search-criteria-module__panelBody--boRbL`
};
export default ___CSS_LOADER_EXPORT___;
